module.exports = __webpack_public_path__ + "static/fonts/NotoSansCJKkr-Light.f94cac3.eot";